import { _baseGetFetch, _baseDeleteFetch, ApiEnum, _basePostFetch, _basePutFetch, _basePatchFetch } from './baseFetch'
const cycleFaultsUploadsLimit = 20

export const getModelsTrobleshoot = (queryParams) => {
  return _baseGetFetch(`/troubleshooting`, queryParams)
}

export const getFaultsUpload = async (queryParams) => {
  return _baseGetFetch(`/troubleshooting`, { ...queryParams, maxResults: cycleFaultsUploadsLimit }, ApiEnum.admin)
}

export const getFaultById = async (id) => {
  return _baseGetFetch(`/troubleshooting/${id}`, undefined, ApiEnum.admin)
}

export const getFaultUserGroups = async () => {
  return _baseGetFetch(`/troubleshooting/faults/user-groups`, undefined, ApiEnum.admin)
}

export const validateFaultModels = async (queryParams) => {
  return _baseGetFetch(`/troubleshooting/faults`, queryParams, ApiEnum.admin)
}

export const postFault = async (body) => {
  return _basePostFetch(`/troubleshooting`, body, ApiEnum.admin)
}

export const putFault = async (faultId, body) => {
  return _basePutFetch(`/troubleshooting/${faultId}`, body, ApiEnum.admin)
}

export const patchFaultDefinition = async (faultId, definitionId, body) => {
  return _basePatchFetch(`/troubleshooting/${faultId}/definitions/${definitionId}`, body, ApiEnum.admin)
}

export const postFaultDefinition = async (faultId, body) => {
  return _basePostFetch(`/troubleshooting/${faultId}/definitions`, body, ApiEnum.admin)
}

export const deleteFault = async (faultId) => {
  return _baseDeleteFetch(`/troubleshooting/${faultId}`, undefined, ApiEnum.admin)
}

export const deleteFaultDefinition = async (faultId, definitionId) => {
  return _baseDeleteFetch(`/troubleshooting/${faultId}/definitions/${definitionId}`, undefined, ApiEnum.admin)
}
